// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__jlF-H","active":"Toggle_active__73v4L","ball":"Toggle_ball__Bk7co"};